// For Nuxt 3
import { config, library } from "@fortawesome/fontawesome-svg-core";
import {
  faFacebookSquare,
  faInstagramSquare,
  faLinkedin,
  faPinterestSquare,
  faTiktok,
  faTwitterSquare,
  faYoutubeSquare
} from "@fortawesome/free-brands-svg-icons";
import {
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsRotate,
  faBell,
  faCaretDown,
  faCaretUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faComments,
  faDownload,
  faEnvelope,
  faInfo,
  faMinus,
  faPause,
  faPenToSquare,
  faPhone,
  faPlay,
  faPlus,
  faQuoteRight,
  faQuotes,
  faRightFromBracket,
  faRightToBracket,
  faRotateRight,
  faSquareEnvelope,
  faStar,
  faTriangleExclamation,
  faXmark
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// This is important, we are going to let Nuxt worry about the CSS
config.autoAddCss = false;

// You can add your icons directly in this plugin. See other examples for how you
// can add other styles or just individual icons.
library.add(
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowsRotate,
  faBell,
  faCaretDown,
  faCaretUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faCircleMinus,
  faCirclePlus,
  faCircleQuestion,
  faComments,
  faDownload,
  faEnvelope,
  faInfo,
  faMinus,
  faPause,
  faPenToSquare,
  faPhone,
  faPlay,
  faPlus,
  faQuoteRight,
  faQuotes,
  faRightFromBracket,
  faRightToBracket,
  faRotateRight,
  faSquareEnvelope,
  faStar,
  faTriangleExclamation,
  faXmark,
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faInstagramSquare,
  faYoutubeSquare,
  faTiktok,
  faPinterestSquare
);

export default defineNuxtPlugin({
  setup: (nuxtApp) => {
    nuxtApp.vueApp.component("font-awesome-icon", FontAwesomeIcon);
  },
  parallel: true
});
